import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "../SvgIcon.js";
const s = (h) => /* @__PURE__ */ r(t, { ...h, children: [
  /* @__PURE__ */ o("path", { d: "M14.1798 12.5013h3.3242V2.49576H7.49844v3.33518h6.68136v6.67036ZM5.8199 7.49863H2.49576V17.5041H12.5013V14.169H5.8199V7.49863Z" }),
  /* @__PURE__ */ o("path", { d: "M12.5012 7.49863H7.49844v5.00277h5.00276V7.49863Z" })
] });
export {
  s as DiffFiles
};
//# sourceMappingURL=DiffFiles.js.map
